import React from "react";
const IconInstagram = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="M12.425 10a2.424 2.424 0 1 0-4.849 0 2.424 2.424 0 0 0 4.849 0Z" />
      <path
        fillRule="evenodd"
        d="M9.758 4.038h-.41v-.002c-1.355.002-1.615.01-2.286.041-.71.033-1.094.15-1.35.25-.34.133-.583.29-.837.545a2.253 2.253 0 0 0-.544.836c-.1.257-.218.642-.25 1.35-.036.767-.043.996-.043 2.939 0 1.942.007 2.172.042 2.939.033.709.151 1.094.25 1.35.133.34.29.581.545.835.254.255.497.413.836.544.257.1.642.219 1.35.251.767.035.997.043 2.94.043 1.941 0 2.171-.008 2.938-.043.71-.032 1.094-.15 1.35-.25.34-.132.582-.29.836-.544a2.25 2.25 0 0 0 .544-.836c.1-.256.218-.64.25-1.35.036-.767.043-.997.043-2.938 0-1.94-.007-2.17-.042-2.938-.033-.709-.151-1.093-.25-1.35a2.257 2.257 0 0 0-.545-.836 2.25 2.25 0 0 0-.836-.544c-.256-.1-.64-.218-1.35-.25-.767-.035-.997-.042-2.939-.042h-.242Zm3.252 2.08a.873.873 0 1 1 1.745 0 .873.873 0 0 1-1.745 0ZM6.266 10a3.735 3.735 0 1 1 7.47 0 3.735 3.735 0 0 1-7.47 0Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.186C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.186C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm6.457.041c.775-.035 1.023-.044 2.998-.044h-.002c1.976 0 2.223.009 2.998.044.775.036 1.303.158 1.767.338.479.186.883.434 1.288.839.405.404.653.81.84 1.288.178.462.3.991.337 1.765.035.776.044 1.024.044 2.999s-.009 2.222-.044 2.998c-.036.774-.159 1.303-.338 1.765a3.568 3.568 0 0 1-.84 1.289c-.403.404-.808.653-1.286.839-.463.18-.992.302-1.766.338-.776.035-1.023.044-2.999.044-1.974 0-2.222-.009-2.998-.044-.774-.036-1.303-.158-1.765-.338a3.56 3.56 0 0 1-1.288-.84 3.563 3.563 0 0 1-.839-1.288c-.18-.462-.302-.99-.338-1.765-.035-.776-.044-1.023-.044-2.998 0-1.975.01-2.223.044-2.999.035-.774.158-1.303.338-1.765a3.57 3.57 0 0 1 .84-1.288c.404-.405.81-.653 1.288-.839.462-.18.99-.302 1.765-.338Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IconInstagram;
